import { CenterR, P, Pivot, R, Segments } from "apparatus/library/common";
import { Group, Path, PointText, Shape } from "paper";
import { setDefaultStyle } from "../../draw";
export class Conductimeter {
    constructor() {
        this.drivers = [
            {
                type: "rectangle",
                minX: -150, maxX: 150,
                minY: 0, maxY: 200,
                toAppearance: (f, p) => f({ probeX: p.x, probeY: p.y }),
                fromAppearance: a => P(a.probeX, a.probeY),
                scale: 1.0,
            }
        ];
    }
    render(appearance) {
        let probeOffsetX = appearance.probeX;
        let probeOffsetY = appearance.probeY;
        // Create a reader
        let casing = Shape.Rectangle(R(0, 0, 60, 100, Pivot.TOP_CENTER), 4);
        casing.fillColor = "#dddddd";
        setDefaultStyle(casing);
        let screen = Shape.Rectangle(R(0, 7, 46, 25, Pivot.TOP_CENTER), 2);
        screen.strokeWidth = 2.0;
        screen.strokeColor = "#777777";
        screen.fillColor = "white";
        let button = Shape.Circle(P(-10, 80), 7);
        button.fillColor = "#5c9adb";
        button.strokeWidth = 2.0;
        button.strokeColor = "#3c6fa6";
        let button2 = Shape.Circle(P(10, 80), 7);
        button2.fillColor = "#5c9adb";
        button2.strokeWidth = 2.0;
        button2.strokeColor = "#3c6fa6";
        let display = new PointText({
            point: P(0, 25),
            content: appearance.reading,
            fillColor: 'black',
            fontFamily: 'sans-serif',
            fontSize: 15,
            justification: "center",
        });
        let unitLabel = new PointText({
            point: P(-20, 50),
            content: appearance.units,
            fillColor: "#888888",
            fontFamily: 'sans-serif',
            fontSize: 14,
            justification: "left",
        });
        let reader = new Group([casing, screen, display, unitLabel, button, button2]);
        // Create the probe
        let probeRod = Shape.Rectangle(CenterR(0, 60, 10, 120));
        probeRod.setGradientFill("right", [["#444444", 0.0], ["#222222", 1.0]]);
        let probeTop = Shape.Rectangle(CenterR(0, 15, 13, 30));
        probeTop.fillColor = "#cccccc";
        probeTop.strokeColor = "#aaaaaa";
        probeTop.strokeWidth = 2.0;
        let probe = new Group([probeRod, probeTop]);
        probe.position = probe.position.add(P(probeOffsetX, probeOffsetY));
        // Create the wire.
        let wire = new Path(Segments([[0, 100], undefined, [0, 50]], [[probeOffsetX, probeOffsetY], [0, -50]]));
        setDefaultStyle(wire);
        let graphic = new Group([reader, probe, wire]);
        var hitShapes = [
            probe.bounds.toShape(),
            reader.bounds.toShape(),
        ];
        return {
            graphic, hitShape: hitShapes, pivot: casing.bounds.center,
            watermark: P(20, -5)
        };
    }
    static convertToLatest(old) {
        if (!old.probeX) {
            old.probeX = old.position == "right" ? 150 : -150;
            old.probeY = 100;
        }
        return old;
    }
}
Conductimeter.properties = {
    label: "Conductimeter",
    defaultAppearance: {
        reading: "0.0",
        units: "µS/cm",
        probeX: 150,
        probeY: 100,
    },
    appearanceSpecs: [
        {
            spec: "text", key: "reading", label: "Reading",
            numbersOnly: true, maxLength: 6,
        },
        {
            spec: "radio", key: "units", label: "Units",
            options: [
                { value: "µS/cm", label: "µS/cm" },
                { value: "S/m", label: "S/m" },
            ],
        }
    ],
};
